export default __webpack_public_path__ + "static/media/Icons_Settings_Regular.1bf724fe.svg";